export default __webpack_public_path__ + "static/media/upload-cloud.a75d531b.svg";